import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import * as moment from "moment"
import { apiError } from "../../store/actions"
import FieldValidation from "../../components/Common/FieldValidation"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import {
  getAllRoles,
  createRole,
  deleteRole,
  editRole,
} from "../../store/roles/actions"
//redux
import { useSelector, useDispatch } from "react-redux"
import {
  capitalizeFirstLetter,
  getCurrentUserFromApi,
  hasPermission,
} from "../../helpers/helpers"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getCurrentUser } from "../../helpers/helpers"
import {
  getAllUsers,
  createUser,
  deleteUser,
  updateUser,
} from "store/users/actions"
import { getAllPermissions } from "store/permissions/actions"
import {sitename} from "../../constants/constants";

const Users = props => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getAllRoles())
    dispatch(getAllPermissions())
  }, [])
  const urlParams = new URLSearchParams(props.location.search)
  const AdminUsers = useSelector(state => state.users.Index ?? [])
  const Roles = useSelector(state => state.roles.Index ?? [])
  const formErrors = useSelector(state => state?.CommonState)
  const loggedInUser = JSON.parse(localStorage.getItem("user"))
  const currentUser = urlParams.get("name")

  useEffect(() => {
    dispatch(getAllUsers(getCurrentUserFromApi(props.location.search)))
  }, [currentUser])

  const selectRow = {
    mode: "checkbox",
  }

  const [modal, setModal] = useState(false)
  const [user, setUser] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const pageOptions = {
    sizePerPage: 10,
    totalSize: AdminUsers.length,
    custom: true,
  }
  const { SearchBar } = Search

  const AdminUsersColumns = [
    {
      dataField: "id",
      text: "User Id",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (_cellContent, row) => (
        <div className="text-body fw-bold">{row.id}</div>
      ),
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => {
        let { name } = row
        name = name?.replace("-", " ")
        name = capitalizeFirstLetter(name)
        return <div className="text-body fw-bold capitalize">{name}</div>
      },
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => {
        const { email } = row
        return <div className="text-body fw-bold">{email}</div>
      },
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => (
        <>
          <div className="d-flex gap-3">
            {hasPermission("update-end_users") && (
              <Link
                to="#"
                className="text-success"
                onClick={e => handleEditUser(user, e)}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
            )}

            {loggedInUser.user.id !== user.id &&
              hasPermission("delete-end_users") && (
                <Link
                  to="#"
                  className="text-danger"
                  onClick={e => handleDeleteUser(user, e)}
                >
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                  />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </Link>
              )}
          </div>
        </>
      ),
    },
  ]

  const EndUserColumns = [
    {
      dataField: "id",
      text: "User Id",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (_cellContent, row) => (
        <div className="text-body fw-bold">{row.id}</div>
      ),
    },
    {
      dataField: "phone_number",
      text: "Phone Number",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => {
        let { phone_number } = row
        return (
          <div className="text-body fw-bold capitalize">{phone_number}</div>
        )
      },
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => (
        <>
          <div className="d-flex gap-3">
            {loggedInUser.user.id !== user.id &&
              hasPermission("delete-end_users") && (
                <Link
                  to="#"
                  className="text-danger"
                  onClick={e => handleDeleteUser(user, e)}
                >
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                  />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </Link>
              )}
          </div>
        </>
      ),
    },
  ]
  const columns = currentUser == "end-user" ? EndUserColumns : AdminUsersColumns

  // useEffect(() => {
  //   dispatch(getAllUsers(getCurrentUserFromApi(props.location.search)))
  // }, [props.location.search])
  const toggle = () => {
    setModal(!modal)
  }
  const handleNewUserClick = () => {
    setUser("")
    setIsEdit(false)
    dispatch(apiError(""))
    toggle()
  }
  const toLowerCase1 = str => {
    return str.toLowerCase()
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  const handleDeleteUser = (user, e) => {
    e.preventDefault()
    if (user.id !== undefined) {
      dispatch(deleteUser(urlParams.get("name"), user.id))
    }
  }
  const handleEditUser = (user, e) => {
    e.preventDefault()
    setUser({
      id: user.id,
      name: capitalizeFirstLetter(user.name.replace("-", " ")),
      email: user.email,
    })

    setIsEdit(true)
    dispatch(apiError(""))

    toggle()
  }

  const handleValidAdminUserSubmit = (e, values) => {
    const role_id = Roles?.find(
      role =>
        role.name.toLowerCase() == getCurrentUserFromApi(props.location.search)
    )["id"]
    const User = {
      name: values["Name"],
      email: values["Email"],
      password: values["Password"],
      role_id,
      currentUser: getCurrentUserFromApi(props.location.search),
      user_id: user.id,
    }
    if (isEdit) {
      dispatch(updateUser(User, toggle))
    } else {
      // create new Admin user
      dispatch(createUser(User, toggle))
    }
  }

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs
            title="Admin"
            breadcrumbItem={getCurrentUser(props.location.search)}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={columns}
                    data={AdminUsers}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        data={AdminUsers}
                        columns={columns}
                        bootstrap4
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              {currentUser !== "end-user" && (
                                <Col sm="8">
                                  <div className="text-sm-end">
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded  mb-2 me-2"
                                      onClick={handleNewUserClick}
                                    >
                                      <i className="mdi mdi-plus me-1" />
                                      {`Create New ${getCurrentUser(
                                        props.location.search
                                      )}`}
                                    </Button>
                                  </div>
                                </Col>
                              )}
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField="id"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    selectRow={selectRow}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    ref={node}
                                    rowClasses={"mytable-hover-row"}
                                  />
                                </div>
                                <Modal isOpen={modal} toggle={toggle} centered>
                                  <ModalHeader toggle={toggle} tag="h4">
                                    {!!isEdit
                                      ? `Edit ${getCurrentUser(
                                          props.location.search
                                        )}`
                                      : `Create New ${getCurrentUser(
                                          props.location.search
                                        )} User`}
                                  </ModalHeader>
                                  <ModalBody>
                                    <AvForm
                                      onValidSubmit={handleValidAdminUserSubmit}
                                    >
                                      <Row form>
                                        <Col className="col-12">
                                          <div className="mb-3">
                                            <AvField
                                              name="Name"
                                              label="Name"
                                              type="text"
                                              errorMessage="This is a required field"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              value={user.name || ""}
                                              className={
                                                formErrors && formErrors?.name
                                                  ? "av-invalid is-invalid"
                                                  : "form-control"
                                              }
                                            />
                                          </div>
                                          {formErrors?.name ? (
                                            <FieldValidation
                                              errorMessage={formErrors?.name}
                                            />
                                          ) : null}
                                        </Col>
                                      </Row>
                                      <Row form>
                                        <Col className="col-12">
                                          <div className="mb-3">
                                            <AvField
                                              name="Email"
                                              label="Email"
                                              type="email"
                                              errorMessage="This is a required field"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              value={user.email || ""}
                                              className={
                                                formErrors && formErrors?.email
                                                  ? "av-invalid is-invalid"
                                                  : "form-control"
                                              }
                                            />
                                          </div>
                                          {formErrors?.email ? (
                                            <FieldValidation
                                              errorMessage={formErrors?.email}
                                            />
                                          ) : null}
                                        </Col>
                                      </Row>
                                      <Row form>
                                        <Col className="col-12">
                                          <div className="mb-3">
                                            <AvField
                                              name="Password"
                                              label="Password"
                                              type="password"
                                              value={null}
                                              className={
                                                formErrors &&
                                                formErrors?.password
                                                  ? "av-invalid is-invalid"
                                                  : "form-control"
                                              }
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col>
                                          <div className="text-end">
                                            <button
                                              type="submit"
                                              className="btn btn-success save-user"
                                            >
                                              Save
                                            </button>
                                          </div>
                                        </Col>
                                      </Row>
                                    </AvForm>
                                  </ModalBody>
                                </Modal>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Users)
